import { createFileRoute } from "@tanstack/react-router";

import { OnboardingJobsPage } from "@/pages/Sales";

export const Route = createFileRoute("/app/sales/onboarding-jobs/")({
  component: OnboardingJobsPage,
});
